// Login.js
import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import HolomenuTitle from "../../components/holomenuTitle";
import { useAuth } from "../../contexts/AuthContext";
import EmailLoginModel from "../Startup/EmailLoginMode";
import BackgroundLogin from "./backgroundLogin";
import LoginForm from "./loginForm";

const Login = () => {
  const [restaurantName, setRestaurantName] = useState("");
  const [error, setError] = useState(null);
  const [isEmailLoginOpen, setIsEmailLoginOpen] = useState(false);
  const [invitedEmail, setInvitedEmail] = useState("");
  const {
    loginUser,
    loginByInvite,
    requestEmailVerification,
    verifyEmailCode,
  } = useAuth();

  const handleLogin = async (restaurant = restaurantName, redirect) => {
    try {
      await loginUser(restaurant, redirect);
    } catch (err) {
      setError(err.message);
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const inviteToken = params.get("token");
    const restaurantNameQueryPre = params.get("restaurant_name");
    const restaurantNameQuery = restaurantNameQueryPre
      ? decodeURIComponent(restaurantNameQueryPre)
      : restaurantNameQueryPre;

    // Clear any cached session before processing a fresh login URL — otherwise
    // the previous session's restaurant_id sticks and overrides the new one.
    if (inviteToken || restaurantNameQuery) {
      localStorage.removeItem("token");
    }

    if (inviteToken) {
      (async () => {
        try {
          const { email } = await loginByInvite(inviteToken);
          setInvitedEmail(email || "");
          setIsEmailLoginOpen(true);
          window.history.replaceState({}, "", "/login");
        } catch (err) {
          setError(err.message);
        }
      })();
      return;
    }

    if (restaurantNameQuery) {
      setRestaurantName(restaurantNameQuery);
      handleLogin(restaurantNameQuery);
    }
  }, []);

  const handleEmailVerificationRequest = async (email) => {
    setError(null);
    try {
      await requestEmailVerification(email);
      return true;
    } catch (err) {
      setError(err.message || "Failed to send verification code.");
      return false;
    }
  };

  const handleEmailLogin = async (email, code) => {
    setError(null);
    try {
      await verifyEmailCode(email, code);
      setIsEmailLoginOpen(false);
    } catch (err) {
      setError(err.message || "Invalid verification code.");
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100svh",
        position: "relative",
        px: { xs: 2, sm: 0 },
      }}
    >
      <BackgroundLogin />
      <HolomenuTitle />
      <LoginForm
        restaurantName={restaurantName}
        setRestaurantName={setRestaurantName}
        handleLogin={handleLogin}
        error={error}
      />
      <EmailLoginModel
        isEmailLoginOpen={isEmailLoginOpen}
        handleCloseEmailLogin={() => setIsEmailLoginOpen(false)}
        handleEmailVerificationRequest={handleEmailVerificationRequest}
        handleEmailLogin={handleEmailLogin}
        error={error}
        prefillEmail={invitedEmail}
      />
    </Box>
  );
};

export default Login;
